import './index.scss';
import { useParams, useNavigate } from 'react-router-dom';
import chevronTable from '../../../../../../../assets/icons/chevronTable.svg';
import Header from '../../../../../../../components/Header/Header';
import useSafeLock from '../../../../../../../hooks/useSafeLock';
import NoData from '../../../../../../../components/NoData/NoData';
import { useEffect, useState } from 'react';
import { Loader } from '@piggytechng/component-library';
import SafelockSearchModal, { EMPTY_SAFELOCK_SEARCH } from './SafelockSearchModal';
import { SafelockSearchParams } from '../../../../../../../types';

const index = () => {
  const params = useParams();
  const id = params.id as string;
  const activeTab = params.activeTab as string;
  const { pendingSafelocksQ, completedSafelocksQ, safelockSearch, searchSafelocks, clearSafelockSearch } =
    useSafeLock();

  const [activeTabTransactions, setActiveTabTransactions] = useState([]);
  const [searchModal, setSearchModal] = useState(false);
  const [searchParams, setSearchParams] = useState<SafelockSearchParams>({ ...EMPTY_SAFELOCK_SEARCH });

  const status = activeTab === 'active' ? 0 : 1;

  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab === 'active') {
      setActiveTabTransactions(pendingSafelocksQ?.list ?? []);
    } else {
      setActiveTabTransactions(completedSafelocksQ?.list ?? []);
    }
  }, [activeTab, pendingSafelocksQ, completedSafelocksQ]);

  const applySearch = (filters: SafelockSearchParams) => {
    setSearchParams(filters);
    searchSafelocks(id, status, filters);
  };

  const resetSearch = () => {
    setSearchParams({ ...EMPTY_SAFELOCK_SEARCH });
    clearSafelockSearch();
  };

  const list = safelockSearch.isActive ? safelockSearch.list : activeTabTransactions;

  return (
    <div className="view-all-target">
      <Header name={activeTab + ' ' + 'Safelocks'} backButton />

      <div className="content">
        <div className="customers-filter">
          <div className="input-field pointer" onClick={() => setSearchModal(true)}>
            <input type="text" placeholder="Search by Safelock ID, title, amount or date" readOnly />
          </div>
          <div className="query-filter pointer" onClick={() => setSearchModal(true)}>
            <div>
              <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                  stroke="#1E293B"
                  strokeWidth="1.5"
                  strokeLinecap="square"
                />
              </svg>
            </div>
            <div>Search</div>
          </div>
          {safelockSearch.isActive && (
            <div className="query-filter pointer" onClick={resetSearch}>
              <div></div>
              <div>Reset</div>
            </div>
          )}
        </div>

        {safelockSearch.isActive && !safelockSearch.isLoading && (
          <p className="search-summary">
            {safelockSearch.total
              ? `Showing ${safelockSearch.list.length} of ${safelockSearch.total} result${
                  safelockSearch.total === 1 ? '' : 's'
                }`
              : 'No safelocks match your search'}
          </p>
        )}

        <div className="wallet-safelock-page">
          <div className="safelocks-table flex--4">
            {safelockSearch.isLoading ? (
              <div className="page-loader">
                <Loader color="#0F60D6" />
              </div>
            ) : list?.length ? (
              list?.map((item: any, key: any) => (
                <div
                  className="row-t pointer flex--2"
                  key={key}
                  onClick={() => {
                    navigate(`/view-safelock/${id}/${item.safelockId}`);
                  }}
                >
                  <div className="flex--2">
                    <div className="img-cont">
                      <img src={item.image} alt="" />
                    </div>

                    <div className="sect-1 flex--4">
                      <h3>
                        {item.title}
                        {item?.isRollover && <span className="rollover-badge">Rolled Over</span>}
                      </h3>
                      <p>{item?.keyPoints[0]?.value}</p>
                      <small>{item?.keyPoints[0]?.label}</small>
                    </div>
                  </div>

                  <div className="sect-2 end flex--4">
                    <small>{item.progressText}</small>
                  </div>
                  <img className="chevron-table" src={chevronTable} />
                </div>
              ))
            ) : (
              <NoData
                message={
                  safelockSearch.isActive
                    ? 'No safelocks match your search.'
                    : `No ${activeTab === 'active' ? 'Ongoing' : 'Completed'} Safelock at the moment.`
                }
                actionText={safelockSearch.isActive ? 'Clear search' : undefined}
                action={safelockSearch.isActive ? resetSearch : undefined}
              />
            )}
          </div>
        </div>
      </div>

      <SafelockSearchModal
        modalIsOpen={searchModal}
        setIsOpen={setSearchModal}
        data={searchParams}
        searchDataBy={applySearch}
        onClear={resetSearch}
      />
    </div>
  );
};

export default index;
